import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker } from '@fortawesome/free-brands-svg-icons';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "Vue",
    "TypeScript",
    "JavaScript",
    "Java",
    "Node",
    "SpringBoot",
    "HTML",
    "CSS",
    "SCSS",
    "Tailwind",
    "Flask",
    "Python",
    "SQL",
    "PostgreSQL",
    "Postman"
];

const labelsSecond = [
    "Git",
    "GitLab",
    "Docker",
    "Terraform",
    "AWS",
    "Azure",
    "GCP",
    "Linux",
    "Snyk",
    "Trivy",
    "SonarQube",
];

const labelsThird = [
    "Snyk",
    "Trivy",
    "SonarQube",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x" className={"expertise-icon"}/>
                    <h3>Full Stack Web Development</h3>
                    <p>I have considerable experience building websites, both on the backend and frontend. I am proficient in technologies like React, Node, and JavaScript.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x" className={"expertise-icon"}/>
                    <h3>DevOps & Automation</h3>
                    <p>After the application is developed, I assist clients in configuring DevOps testing, automating CI/CD pipelines, and optimizing deployment processes to ensure a seamless launch.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faShieldAlt } size="3x" className={"expertise-icon"}/>
                    <h3>Security</h3>
                    <p>DevOps requires lots of security aspects too. These are some tools I have integrated and utilized in CI/CD pipelines.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;